export default __webpack_public_path__ + "d6484fce1ef428d5bd94a903d7973395.woff2";